import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const steps = [
  { num: '01', title: 'Setup School', desc: 'Configure classes, subjects, teachers and departments in minutes.', color: '#2563eb' },
  { num: '02', title: 'Enroll Students', desc: 'Bulk import or manual registration with parent details.', color: '#0891b2' },
  { num: '03', title: 'Go Live Daily', desc: 'Attendance, fees, exams and notices — all managed digitally.', color: '#7c3aed' },
  { num: '04', title: 'Engage Parents', desc: 'Automated alerts keep parents informed in real-time.', color: '#059669' },
  { num: '05', title: 'Analyze & Grow', desc: 'Academic and financial reports drive better decisions.', color: '#dc2626' },
];

const ProcessTimeline = () => (
  <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: '#fff', overflow: 'hidden' }}>
    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center', mb: 8 }}>
        <Typography sx={{ color: '#2563eb', fontWeight: 700, fontSize: 13, letterSpacing: 2, mb: 1.5, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>Onboarding Process</Typography>
        <Typography variant="h2" sx={{ fontWeight: 800, color: '#0f172a', fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '1.8rem', md: '2.6rem' } }}>
          Up & Running in 5 Simple Steps
        </Typography>
      </Box>

      {/* Desktop horizontal timeline */}
      <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'flex-start', justifyContent: 'space-between', position: 'relative', mt: 4 }}>
        {/* Connecting line */}
        <Box sx={{ position: 'absolute', top: 32, left: '10%', right: '10%', height: 3, background: 'linear-gradient(90deg, #2563eb, #0891b2, #7c3aed, #059669, #dc2626)', borderRadius: 2, zIndex: 0 }} />
        {steps.map((s, i) => (
          <Box key={i} sx={{ flex: 1, textAlign: 'center', px: 1, position: 'relative', zIndex: 1 }}>
            <Box sx={{
              width: 64, height: 64, borderRadius: '50%', bgcolor: s.color,
              display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 2,
              boxShadow: `0 8px 24px ${s.color}55`, border: '4px solid #fff',
            }}>
              <Typography sx={{ color: '#fff', fontWeight: 900, fontFamily: "'Montserrat', sans-serif", fontSize: 18 }}>{s.num}</Typography>
            </Box>
            <Typography sx={{ fontWeight: 800, color: '#0f172a', fontFamily: "'Montserrat', sans-serif", fontSize: '0.9rem', mb: 1 }}>{s.title}</Typography>
            <Typography sx={{ color: '#64748b', fontFamily: "'Montserrat', sans-serif", fontSize: 13, lineHeight: 1.6 }}>{s.desc}</Typography>
          </Box>
        ))}
      </Box>

      {/* Mobile vertical */}
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        {steps.map((s, i) => (
          <Box key={i} sx={{ display: 'flex', gap: 2.5, mb: 4, alignItems: 'flex-start' }}>
            <Box sx={{ width: 52, height: 52, borderRadius: '50%', bgcolor: s.color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: `0 6px 18px ${s.color}55` }}>
              <Typography sx={{ color: '#fff', fontWeight: 900, fontFamily: "'Montserrat', sans-serif" }}>{s.num}</Typography>
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 800, color: '#0f172a', fontFamily: "'Montserrat', sans-serif", fontSize: '0.95rem', mb: 0.5 }}>{s.title}</Typography>
              <Typography sx={{ color: '#64748b', fontFamily: "'Montserrat', sans-serif", fontSize: 14, lineHeight: 1.7 }}>{s.desc}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Container>
  </Box>
);

export default ProcessTimeline;
